export default function generateTrayWizardUrl(solutionInstanceId, wizardAuthCode) {
  return `https://embedded.tray.io/external/solutions/socialive/configure/${solutionInstanceId}?code=${wizardAuthCode}`;
}
